import { Component
}  from '@angular/core';
import { DialogRef, ModalComponent } from 'ngx-modialog';
import { PlayerModalContent }    from './player-modal-content.component';

@Component({
    selector: 'app-player-modal',
    templateUrl: './player-modal.component.html',
    styleUrls: ['./player-modal.component.css']
})
export class PlayerModalComponent implements ModalComponent<PlayerModalContent> {
    context: PlayerModalContent;
    sources: Array<Object>;

    constructor(public dialog: DialogRef<PlayerModalContent>) {
        this.context = dialog.context;
        this.sources = [
            {
                src: 'https://new-api.virtualevaluator.net/explainer.mp4',
                type: 'video/mp4'
            }
        ];
    }

    beforeDismiss() {
        return false;
    }

    beforeClose() {
        return false;
    }

    onCancel() {
        this.dialog.close();
    }

    closeModal() {
        this.dialog.close();
    }
}




// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/player-modal/player-modal.component.ts